import { render, staticRenderFns } from "./DeviceInfoDetalhes.vue?vue&type=template&id=47739810&"
import script from "./DeviceInfoDetalhes.vue?vue&type=script&lang=js&"
export * from "./DeviceInfoDetalhes.vue?vue&type=script&lang=js&"
import style0 from "./DeviceInfoDetalhes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports